import * as moment from 'moment';
import { Moment } from 'moment';

export default class DateTimeHelper {
  static getTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  public static addHoursAndMinutes(date: Date | string, hours: number, minutes: number) {
    let newDate = new Date(date);
    newDate.setHours(hours);
    newDate.setMinutes(minutes);
    newDate.setSeconds(0);

    return newDate;
  }

  public static addHoursAndMinutesFromTimeString(date: Date | string, time: string) {
    let hours: number = parseInt(time.substring(0, 2));
    let minutes: number = parseInt(time.substring(3));

    return DateTimeHelper.addHoursAndMinutes(date, hours, minutes);
  }

  public static getTimeStringFromDate(date: Date): string {
    let newDate = new Date(date);
    let hours = newDate.getUTCHours().toString();
    let minutes = newDate.getUTCMinutes().toString();

    hours = DateTimeHelper.padLeadingZero(hours);
    minutes = DateTimeHelper.padLeadingZero(minutes);

    return `${hours}:${minutes}`;
  }

  public static getTimeStamp(date: Date): string {
    return date.getFullYear() + '' + (date.getMonth() + 1) + '' + date.getDate() + '_' + date.getHours() + '' + date.getMinutes();
  }

  public static getMonthDifference(startDate: Date, endDate: Date): Number {
    startDate = new Date(startDate);
    endDate = new Date(endDate);
    let months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
    months -= startDate.getMonth();
    months += endDate.getMonth();
    return months;
  }

  private static padLeadingZero(value: string) {
    if (value.length === 1) {
      value = `0${value}`;
    }

    return value;
  }

  public static getStartOfYear(year: number): Date {
    return new Date(year, 0, 1);
  }

  public static getEndOfYear(year: number): Date {
    return new Date(year, 11, 31);
  }

  public static convertDate(date: Date): Date {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  }

  public static convertDateTime(date: Date): Date {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
  }

  public static convertDateToUTCDate(date: Date): Date {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  }

  public static convertDateTimeToUTCDateTime(date: Date): Date {
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
  }

  public static getUTCDate(date: Date): Date {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0);
  }

  public static getUTCDateTime(date: Date): Date {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), 0);
  }

  public static daysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  }

  public static getToday(): Moment {
    return this.getStartOfDayDate(moment());
  }

  public static formatFileDate(date?: Date): string {
    if (!date) {
      date = this.getStartOfDayDate(moment()).toDate();
    } else {
      date = new Date(date);
    }
    return date.getFullYear().toString() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + date.getDate()).slice(-2);
  }

  public static addDays(date: Date, days: number): Date {
    const addDate = new Date(date);
    addDate.setDate(addDate.getDate() + days);
    return addDate;
  }

  public static getStartOfDayDate(date: Moment): Moment {
    return date.startOf('day');
  }

  public static getStartOfMonthDate(date: Moment): Moment {
    return this.getStartOfDayDate(date)
      .startOf('month');
  }

  public static getEndOfMonthDate(date: Moment): Moment {
    return date.endOf('day')
      .endOf('month');
  }

  public static getStartOfCurrentMonthDate(): Moment {
    const date = moment(new Date());
    return this.getStartOfDayDate(date)
      .startOf('month');
  }

  public static getEndOfCurrentMonthDate(): Moment {
    const date = moment(new Date());
    return date.endOf('day')
      .endOf('month');
  }

  public static getStartOfWeekDate(): Date {
    const today = new Date((new Date).toDateString());
    const startDay = today.getDate() - today.getDay() + 1;
    return new Date(today.setDate(startDay))
  }

  public static getEndOfWeekDate(): Date {
    const today = new Date((new Date).toDateString());
    const startDay = today.getDate() - today.getDay();
    const lastDay = startDay + 7;
    return new Date(today.setDate(lastDay))
  }


  public static timeSpanConvert(n: number): string {
    var num = n;
    var hours = (num / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);

    var h = String(rhours)
    if (h.length == 1) {
      h = '0' + h
    }

    var m = String(rminutes)
    if (m.length == 1) {
      m = '0' + m
    }
    return h + ":" + m;
  }

  public static getDifferenceTime(date: Date): string {
    var now = this.convertDateTime(new Date());
    now.setSeconds(0);
    date = new Date(date);
    date.setSeconds(0);
    var difference = now.getTime() - date.getTime();
    return this.timeSpanConvert(Math.floor(difference / 60000));
  }

  public static getDifferenceBetweenTimes(firstDate: Date, secondDate: Date): number {
    var difference = secondDate.getTime() - firstDate.getTime();
    return difference / 60000 / 60;
  }

  private static readonly iso8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;

  public static isIso8601(value) {
    if (value === null || value === undefined || typeof value !== 'string') {
      return false;
    }

    return this.iso8601.test(value);
  }

  public static addOffset(date: Date): Date {
    date = new Date(date);
    date.setMinutes(date.getMinutes() + (date.getTimezoneOffset() * -1));
    return date;
  }

  public static isStartAndEndTimeLastSecondOfTheDay(startTime: Date, endTime: Date): boolean {
    return startTime.getUTCHours() == 23 && endTime.getUTCHours() == 23 && startTime.getUTCMinutes() == 59 && endTime.getUTCMinutes() == 59 && startTime.getUTCSeconds() == 59 && endTime.getUTCSeconds() == 59;
  }

  public static isStartTimeLastSecondOfTheDay(startTime: Date): boolean {
    return startTime.getUTCHours() == 23 && startTime.getUTCMinutes() == 59 && startTime.getUTCSeconds() == 59;
  }

  public static getHourMinuteFormat(date: Date): string {
    if (date.toString().includes(" ")) {
      const fulltime = date.toTimeString().split(" ")[0].split(':');
      return fulltime[0] + ":" + fulltime[1];
    }
    else {
      const fulltime = date.toString().split("T")[1].split(':');
      return fulltime[0] + ":" + fulltime[1];
    }
  }

  public static getNextQuarterMonth(month: number): number {
    return (Math.floor((month - 1) / 3) + 1) * 3;
  }

  public static getNextQuarterMonthFromZero(monthIndex: number): number {
    return this.getNextQuarterMonth(monthIndex + 1) - 1;
  }

  public static setNextQuarterMonth(date: Date): void {
    const nextMonth = this.getNextQuarterMonthFromZero(date.getMonth());

    date.setMonth(nextMonth);
  }

  public static getNextHalfYearMonth(month: number): number {
    return (Math.floor((month - 1) / 6) + 1) * 6;
  }

  public static getNextHalfYearMonthFromZero(monthIndex: number): number {
    return this.getNextHalfYearMonth(monthIndex + 1) - 1;
  }

  public static setNextHalfYearMonth(date: Date): void {
    const nextMonth = this.getNextHalfYearMonthFromZero(date.getMonth());

    date.setMonth(nextMonth);
  }

  public static dateRangesIntersect(startDate1: Date, endDate1: Date, startDate2: Date, endDate2: Date): boolean {
    return (startDate1 <= endDate2) && (endDate1 >= startDate2);
  }

  public static get maxDate(): Date {
    return new Date(8640000000000000);
  }

  public static toDate(value: Date | Moment | string): Date | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return value;
    }
    else if (value instanceof moment) {
      return (value as Moment).toDate();
    }

    return new Date(value as string);
  }

  public static getDayName(date: string) {
    return new Date(date).toLocaleString('en-us', { weekday: 'long' })
  }

  private static readonly days = ['so', 'mo', 'di', 'mi', 'do', 'fr', 'sa'];

  public static getDayOfWeek(date: string) {
    return this.days[new Date(date).getDay()];
  }
}
